<template>
	<div id="Bigcoffeegatheringdetails" class="centert">
		<!-- 头标签 -->
		<dpubtop></dpubtop>
		<!-- 中间 -->
		<div class="Bigcoffdetails">
			<!-- 头部 -->
			<div class="pub_pub">
				<div class="pub_title">
					<div class="img_logo">
						<img src="../../../imges/lebiao/qzzp.png" alt="">
					</div>
					<div class="title_t">
						<div class="imhg_ti">
							<img src="../../../imges/lebiao/qzzp_font.png" alt="">
						</div>
						<div class="sm_t">
							<div style="float:left"><span>求职</span><span style="color:#D7230C;">招聘</span></div>
							<div class="sm_pub">海量职位/人才</div>
						</div>
					</div>
				</div>
				<div style="width: 0px;height: 36px;border: 1px solid #ececec;float: left;">
					<!-- 中间线 -->
				</div>
				<div class="ckgd_dh">
					<div class="sy">
						<div class="sy_img">
							<img src="../../../imges/details/sy.png" alt="">
						</div>
						<router-link class="sy_title" to="/" style="text-decoration: none;
							">首页</router-link>
					</div>
					<div class="jt" style="margin-top: 0px;">
						<img src="../../../imges/details/jt.png" alt="">
					</div>
					<div class="name">求职招聘</div>
				</div>
				<!-- <div class="Bigcosousuo">
					<el-select v-model="searchData.type" placeholder="请选择" style="width: 25%;float: left;">
						<el-option style="height:40px;" v-for="item in options" :key="item.value" :label="item.label"
							:value="item.value"></el-option>
					</el-select>
					<input v-model="keyword" type="text" placeholder="请输入内容">
					<div @click="selectChild1">
						搜索
					</div>
				</div> -->
				<div class="rwdt_fb_0" @click="qwqe">我要找工作</div>
				<div class="rwdt_fb" @click="qwqe">我要招聘</div>
			</div>
			<!-- 头部结束 -->
			<div class="top_bottom">

				<div style="width: 100%;height: 1480px;">
					<div style="width: 100%;height: 20px;">
						
					</div>
					<router-link tag="div" :to="{ path:'/qzzpdetailist',query:{id:item,title:item.title} }"  v-for="(item,index) in dabing" :key="index"
						style="width: 97%;margin-top: 10px;margin-left: 1%;border: 1px solid #ececec;height: 170px;position: relative;">
						<div style="height: 30px;font-size: 20px;font-weight: 800;margin-top: 10px;margin-left: 10px;">
							{{item.title}}
						</div>
						<div style="height: 30px;margin-left: 10px;margin-top: 10px;">
							{{item.title}} <img src="../../../imges/rz.png" alt=""
								style="width: 18px;height: 20px;margin-left: 10px;margin-right: 10px;" /> {{item.scope}}
						</div>
						<div style="height: 30px;font-size: 14px;margin-top: 10px;margin-left: 10px;">
							经验：{{item.jobexperience}} | 专业：{{item.zhuanye}} | 年龄：{{item.age}}
						</div>

						<div
							style="width: 150px;height: 40px;border: 1px solid #D7230C;border-radius: 5px;line-height: 40px;text-align: center;font-weight: 800;color: #D7230C;position: absolute;right: 10px;bottom: 50px;">
							查看简历
						</div>
					</router-link>
				</div>
				<div style="width: 100%;height: 50px;margin-top: 15px;text-align: center;">
					<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
						:current-page.sync="currentPage" :page-size="pageSize" layout="total, prev, pager, next"
						:total="Totals"></el-pagination>
				</div>
			</div>


		</div>
		<!-- 中间结束 -->
		<!-- 尾标签 -->
		<myfooter></myfooter>
	</div>
</template>

<script>
	import http from "@/utils/http";
	export default {
		data() {
			return {
				options: [{
						value: '职位',
						label: '职位'
					},
					{
						value: '人才',
						label: '人才'
					}
				],
				tags: [],
				dwgmData:'',
				keyword: '',
				searchData: {
					type: '职位',
					keyword: '' //搜索框查询关键字
				},
				currentPage: 1, //当前页
				pageSize: 8, //当前每页数据
				Totals: 18, //总数据条数
				dabing: '',
				gzxzData:'',
				xlyqData:'',
				gzjyData:'',
				gxsjData:'',
				zhpxData:'',
			}
		},
		methods: {
			handleSizeChange(val) {
				console.log(`每页 ${val} 条`);
			},
			async handleCurrentChange(val) {
				let res = await http.get('api/Common/index',{
					type:'content',
					model:'hr',
					mid:'10',
					page:val,
					rows_limit:'8',
				})
				console.log(res)
				this.Totals = res.data.data.count
				this.dabing = res.data.data.list.data
			},
			async xlcx(){
				let res = await http.post('api/hr/job',{
					scope: this.dwgmData,
					work_type: this.gzxzData,
					xueli: this.xlyqData,
					jobexperience: this.gzjyData,
					fid:this.selectLb,
				})
				this.dabing = res.data.data
			},
			async sca(item) {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
				let res = await http.post('api/picture/personal_collection', {
					uid: loginInfo.id,
					title: item.title,
					picture: item.picture,
					pc_link: '/qzzpdetailist?id=' + item.id + '&title=' + item.title,
					url_link: '/qzzpdetailist?id=' + item.id + '&title=' + item.title,
				})
				if (res.data.code == 200) {
					this.$notify({
						title: '成功',
						message: '收藏成功',
						type: 'success'
					});
				} else {
					this.$notify({
						title: '失败',
						message: res.data.msg,
						type: 'error'
					});
				}
			},
			handleClose(tag) {
				let zIndex = 9999;
				this.tags.forEach((item, index) => {
					if (item.title == tag.title) {
						zIndex = index;
					}
				});
				this.tags.splice(zIndex, 1);
				this.gotosb()
			},
			select(title, val) {
				// 综合函数
				let add = 999;
				this.tags.forEach((item, index) => {
					if (item.title == title) {
						add = index;
					}
				});
				if (add == 999) {
					let obj = {
						title: title,
						name: val,
						type: 'danger'
					};
					this.tags.push(obj);
				} else {
					this.tags[add].name = val;
				}
			},
			async qkcx(){
				let res = await http.get('api/hr/job')
				this.dabing = res.data.data
			},
			qwqe() {
				const loginInfo = JSON.parse(window.sessionStorage.getItem('token') || null)
				if (loginInfo == null) {
					this.$router.push({
						path: '/login'
					})
				} else {
					this.$router.push({
						path: '/user'
					})
				}
			},
			async gotosb(){
				let res = await http.get('api/Common/index',{
					type:'content',
					model:'hr',
					mid:'10',
					rows_limit:'8',
				})
				console.log(res)
				this.Totals = res.data.data.list.total
				this.dabing = res.data.data.list.data
			},
			async selectChild1() {
				if (this.keyword == '') {
					alert('请输入内容！')
					return
				}
				if (this.searchData.type == '人才') {
					let res = await http.post('api/Common/index', {
						model: 'hr',
						type: 'content',
						mid: '10',
						title: this.keyword
					})
					this.dabing = res.data.data.list.data
					this.Totals = res.data.data.list.total
					this.pageSize = res.data.data.list.per_page
					this.currentPage = res.data.data.list.current_page
				} else {
					let res = await http.post('api/Common/index', {
						model: 'hr',
						type: 'content',
						mid: '9',
						title: this.keyword
					})
					this.dabing = res.data.data.list.data
					this.Totals = res.data.data.list.total
					this.pageSize = res.data.data.list.per_page
					this.currentPage = res.data.data.list.current_page
				}
			}
		},
		mounted() {
			this.gotosb()
		},
		components: {
			// 尾标签,
			myfooter: resolve => require(['@/components/myfooter'], resolve),
			// 头标签
			dpubtop: resolve => require(['@/components/dpubtop/dpubtop'], resolve),

		}
	}
</script>

<style scoped>
	.centert {
		width: 1200px;
		margin: 0 auto;
	}

	.Bigcoffdetails {
		height: 1600px;
		width: 100%;
	}

	.pub_pub {
		margin-top: 20px;
		border-radius: 0px !important;
		height: 36px;
	}

	.pub_title {
		width: 350px;
		float: left;
	}

	.ctu_::after,
	.pub_title::after {
		content: '';
		display: block;
		clear: both;
	}

	.pub_title>img {
		width: 100%;
		height: 100%;
	}

	.img_logo {
		float: left;
		width: 36px;
		height: 36px;
		overflow: hidden;
	}

	.title_t {
		float: left;
		height: 36px;
		margin-left: 12px;
		font-weight: 600;
		letter-spacing: 3px;
	}

	.imhg_ti {
		height: 12px;
		width: 120px;
		margin-top: -5px;
	}

	.imhg_ti>img {
		width: 100%;
		height: 100%;
	}

	.sm_t {
		height: 26px;
		line-height: 26px;
		font-size: 18px;
		margin-top: 8px;
	}

	.sm_pub {
		float: left;
		margin-left: 12px;
		font-size: 12px;
		color: #5e5d5d;
		cursor: pointer;
	}

	.sy::after,
	.ckgd_dh::after {
		content: '';
		display: block;
		clear: both;
	}

	.ckgd_dh {
		float: left;
		font-size: 12px;
		margin-left: 50px;
	}

	.ckgd_dh>div {
		float: left;
		height: 40px;
		line-height: 42px;
		color: #5e5d5d;
	}


	.name {
		line-height: 43px;
	}

	.sy_img {
		float: left;
		width: 20px;
		height: 20px;
	}

	.sy_img>img {
		margin-top: 13px;
		width: 100%;
		height: 100%;
	}

	.jt>img {
		margin-top: 10px;
	}

	.sy_title {
		float: left;
		height: 40px;
		line-height: 44px;
		margin-left: 6px;
		color: #5e5d5d;
	}

	.jt {
		width: 12px;
		height: 20px;
		margin-left: 6px;
		margin-right: 6px;
	}

	.Bigcosousuo {
		float: left;
		width: 300px;
		height: 36px;
		border: 1px solid #ececec;
		margin-left: 50px;
		background-color: #D7230C;
	}

	/deep/ .Bigcosousuo .el-input__inner {
		border-radius: 0px;
		border-right: none;
		height: 36px;
	}

	.Bigcosousuo>input {
		width: 53%;
		height: 34px;
		float: left;
		border: 0px;
		outline: none;
	}

	.Bigcosousuo>div {
		width: 20%;
		height: 36px;
		float: left;
		line-height: 36px;
		font-size: 20px;
		color: #FFF;
		font-weight: 800;
		text-align: center;
	}

	.rwdt_fb_0 {
		float: left;
		font-size: 17px;
		width: 110px;
		height: 40px;
		text-align: center;
		line-height: 40px;
		margin-left: 50px;
		border: 1px solid #e82904;
		color: #e82904;
		border-radius: 4px;
		cursor: pointer;
	}

	.rwdt_fb {
		float: left;
		font-size: 17px;
		width: 110px;
		height: 40px;
		text-align: center;
		line-height: 40px;
		margin-left: 20px;
		border: 1px solid;
		background-color: #e82904;
		color: #fff;
		border-radius: 4px;
		cursor: pointer;
	}

	/* 头部结束 */
	.top_bottom {
		width: 100%;
		height: 1550px;
		box-shadow: #6e6e6e 0px 0px 10px;
		margin-top: 30px;
	}
</style>
